import React, { useState } from "react";

const PropertyInquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    allowContact: true,
    agreeTerms: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form Submitted! 🚀");
  };

  return (
    <div className="max-w-[350px] mx-auto bg-white p-6 rounded-lg shadow-md border border-gray-200">
      <h2 className="text-xl font-semibold mb-4">
        Looking for a Property in <br />
        <span className="font-bold">Trimurty Divinity</span>
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Name Input */}
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Name"
          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-400"
          required
        />

        {/* Email Input */}
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-red-400"
          required
        />

        {/* Mobile Input */}
        <div className="flex items-center space-x-2 border px-4 py-2 rounded-md">
          <select className="bg-transparent focus:outline-none">
            <option value="+91">IND +91</option>
            <option value="+1">USA +1</option>
            <option value="+44">UK +44</option>
          </select>
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            placeholder="Mobile Number"
            className="flex-1 focus:outline-none"
            required
          />
        </div>

        {/* Checkbox */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            name="allowContact"
            checked={formData.allowContact}
            onChange={handleChange}
            className="w-4 h-4 accent-red-500"
          />
          <label className="text-sm text-gray-700">
            Allow other advertisers with similar properties to contact you
          </label>
        </div>

        {/* Terms Agreement */}
        <div className="text-sm">
          <input
            type="checkbox"
            name="agreeTerms"
            checked={formData.agreeTerms}
            onChange={handleChange}
            className="w-4 h-4 accent-red-500 mr-2"
            required
          />
          <label>
            I Agree to MagicBricks'{" "}
            <a href="#" className="text-red-500 underline">
              Terms of Use
            </a>
          </label>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-red-500 text-white py-3 rounded-md font-bold hover:bg-red-600 transition-all"
        >
          View Phone No.
        </button>
      </form>
    </div>
  );
};

export default PropertyInquiryForm;
